import Cookies from "js-cookie"
import MyContext from "./context"

const MyState = (props) => {
	const auth = Cookies.get("authuser")

	const api = {
		admin: "/spywareassets/api/admin/index",
		global: "/spywareassets/api/global/index",
		public: "/spywareassets/api/public/index",
		student: "/spywareassets/api/student/index",
		login: "/spywareassets/api/login/index",
		stuimg: "/spywareassets/student/",
		gallery: "/spywareassets/gallery/",
	}

	return <MyContext.Provider value={{ api, auth }}>{props.children}</MyContext.Provider>
}
export default MyState
